var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgElectricityBuy = function SvgElectricityBuy(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "EB_1_",
    width: 39.997,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "EB_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EB_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#EB_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeMiterlimit: 10,
    d: "M13.385,12.287V5.139 c0-0.8,0.647-1.447,1.445-1.447c0.798,0,1.446,0.647,1.446,1.447v7.148"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#EB_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeMiterlimit: 10,
    d: "M23.72,12.287V5.139 c0-0.8,0.646-1.447,1.445-1.447c0.798,0,1.445,0.647,1.445,1.447v7.148"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#EB_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 10.08,
    y1: 12.252,
    x2: 29.915,
    y2: 12.252
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#EB_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 19.997,
    y1: 27.44,
    x2: 19.997,
    y2: 36.935
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#EB_2_)",
    fill: "none",
    stroke: "#00C752",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 15.771,
    y1: 17.004,
    x2: 24.223,
    y2: 17.004
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#EB_2_)",
    fill: "none",
    stroke: "#00C752",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 15.771,
    y1: 20.333,
    x2: 24.223,
    y2: 20.333
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#EB_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M29.019,14.784 v3.611c0,4.985-4.039,9.025-9.021,9.025s-9.022-4.04-9.022-9.025v-3.611"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElectricityBuy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/electricity-buy.28ce29e6.svg";
export { ForwardRef as ReactComponent };